import ModalLocationEdit from './ModalLocationEdit';

export default ModalLocationEdit;
